module.exports = __webpack_public_path__ + "img/giphy3.f716430f.gif";